#import "../fragments/AutomationEditorFields.graphql"

query AutomationEditor($id: ID!) {
  automation(id: $id) {
    ...AutomationEditorFields
  }
}
